const SURVEY_STATUS = {
    ACTIVE: "ACTIVE",
    IN_PROGRESS: "In-Progress",
    INACTIVE: "Inactive",
  };
  
  export const SURVEY = {
    SURVEY: "Survey",
    STATUS : { ...SURVEY_STATUS },
    TYPE: {
      SUMMARY: "Summary",
      INDIVIDUAL: "Individual"
    },
    QUESTION__TYPES: {
      MULTIPLE__CHOICE: "MultipleChoice",
      SHORT_ANSWER: "ShortAnswer"
    }
  }